import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { getIcon } from "@/lib/iconRegistry";

const DEFAULT_REASONS = [
  { icon: "Zap", title: "Lightning Fast Processing", desc: "Most applications are confirmed within 15-30 minutes, 24 hours a day." },
  { icon: "LockKeyhole", title: "Bank-Grade Security", desc: "Your documents and payments are protected with enterprise-level encryption." },
  { icon: "BadgeCheck", title: "100% Genuine Service", desc: "Fully compliant, verified processes trusted by thousands of customers." },
  { icon: "HeartHandshake", title: "Dedicated 24x7 Support", desc: "Real humans on WhatsApp and phone, ready to help anytime you need." },
];

export default function WhyChooseUs() {
  const [reasons, setReasons] = useState(DEFAULT_REASONS);
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/site-settings").then((res) => {
      if (res.data.why_choose_us?.length) setReasons(res.data.why_choose_us);
      setContent(res.data.homepage_content?.why_choose_us || {});
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="why-choose-us-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span data-testid="why-choose-us-overline" className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">{content.overline || "Why Gulfudaan"}</span>
          <h2 data-testid="why-choose-us-title" className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mt-3">{content.title || "Why Choose Us"}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((r, i) => {
            const Icon = getIcon(r.icon);
            return (
              <div key={i} data-testid={`why-choose-us-item-${i}`}
                className="p-8 rounded-lg border border-[#E5E1DA] bg-[#FDFCFB] hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="w-12 h-12 rounded-full bg-[color-mix(in_oklab,var(--brand-primary),transparent_90%)] flex items-center justify-center mb-5">
                  <Icon size={22} className="text-[var(--brand-primary)]" />
                </div>
                <h3 className="font-heading text-xl text-[#1A1A1A] mb-2">{r.title}</h3>
                <p className="text-sm text-[var(--brand-secondary)] leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
